/*eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
// import AssetIconService from '@/services/AssetIconService';
import ApiService from '@/services/ApiService';
import { AxiosResponse } from 'axios';
import { IModalData } from '@/services/layers/IModalData';
import IPosition from '@/interfaces/IPosition';
import IFeature from '@/interfaces/IFeature';

import {
  LayerGroup, LeafletEvent, Marker, DivIcon,
  markerClusterGroup,
} from 'leaflet';
import AssetIconService from '../AssetIconService';
import { toRaw } from 'vue';
import MapIconsGeneratorService from '../MapIconsGeneratorService';
import { IClusterIconSettings, IMarkerIconSettings } from '@/interfaces/IMapIconsSettings';

export default class PoiPointsLayerService extends LayerService {
  onClick(e: LeafletEvent, metaData: any, leafletMarker: Marker): void {
    const modalCustomIcon = this.getModalCustomIconTemplate(metaData);

    const poiLayers = store.state.poiLayers.layers;
    const poiCateogory = poiLayers.find((category: any) => category.id === metaData.layer_id);
    const iconCode = poiCateogory && poiCateogory.icon_code ? poiCateogory.icon_code : null;

    const modalData: IModalData = {
        title: metaData.name,
        content: '',
        navigationPoint: leafletMarker,
        lastUpdate: '',
        icon: MapIconsGeneratorService.resolveIconUrl(iconCode, true),
        customIconTemplate: modalCustomIcon,
        templateName: 'TemplateModalPoi',
        metaData: metaData,
        iconClassName: '',
    };
    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.poiPoints;

    return this.generateMarkerClusterLayer(points);
  };

  protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const tempPoi = store.state.settings.mapPoiLayers;
    const filteredCodes = Object.keys(tempPoi).filter(item => (tempPoi as any)[item]);
    const markerClusterGroupInstance = markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 40,
      iconCreateFunction: (cluster) => {
        const population = cluster.getChildCount();
        return new DivIcon({
          html: this.generateClusterHtml(population),
          className: 'custom-cluster-icon',
          iconSize: [this.clusterWidth, this.clusterHeight],
          iconAnchor: [this.clusterWidth / 2, this.clusterHeight / 2],
        });
      },
    });

    positions.features.forEach((feature: any) => {
      if (!feature.geometry) return;

      const { coordinates } = feature.geometry;
      const [lng, lat] = coordinates as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);

      if (filteredCodes.includes(feature.properties.layer_id)) {
        markerClusterGroupInstance.addLayer(toRaw(singleMarker));
      }
    });

    return markerClusterGroupInstance;
  };

  getIconData(metaData: any) {
    let primaryColor: string = '#285397';
    if (metaData.color) {
      primaryColor = metaData.color;
    }
    let iconName: string = metaData.iconUri;
    const { contrast} = store.state;

    return {
      primaryColor,
      iconName,
      contrast,
    }
  };

  getModalCustomIconTemplate(metaData: any) {
    const { contrast} = store.state;
    const { primaryColor, iconName } = this.getIconData(metaData);

    const currentColor = contrast ? '#FFE500' : primaryColor;
    const bgColor = contrast ? '#0F1F31' : '#fff';

    const iconTemplate = `
      <div class="modal__icon-custom-content" style="color: ${currentColor};">
      
      </div>
    `;

    return iconTemplate;
  };

  generateClusterHtml(population: number) {
    const settings: IClusterIconSettings = {
      className: 'map-cluster--poi',
      insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_poi.svg`),
      population,
    };
    const iconHtml = MapIconsGeneratorService.getClusterIcon(settings);
    
    return iconHtml;
  }

  protected generateHtmlPointTemplate = (metaData: any): string => {
    const poiLayers = store.state.poiLayers.layers;
    const poiCateogory = poiLayers.find((category: any) => category.id === metaData.layer_id);
    const iconCode = poiCateogory && poiCateogory.icon_code ? poiCateogory.icon_code : null;

    const settings: IMarkerIconSettings = {
      className: 'map-marker--poi',
      insideIcon: iconCode ?? '', // Provide a fallback value for undefined
      isBase64IconCode: true,
    };
    const iconHtml = MapIconsGeneratorService.getMarkerIcon(settings);

    return iconHtml;
  };
}
